import React from 'react';
import { useSelector } from 'react-redux';

/**
 * ConfirmationNotes
 * 입회 모드 전용 - 확인사항 textarea + 서명하기 버튼 섹션
 *
 * value         : textarea 값
 * onChange      : textarea 변경 콜백
 * onSign        : 서명하기 버튼 클릭 콜백
 * disabled      : true면 비활성화 (다른 사용자 입회 중일 때)
 * lockedByName  : 현재 입회 진행 중인 실제 입회자 이름
 */
export default function ConfirmationNotes({
  value,
  onChange,
  onSign,
  disabled = false,
  lockedByName,
}) {
  const { baseInfo } = useSelector((state) => state.permit);

  return (
    <section className="space-y-3 pb-5">
      <div className="flex items-center gap-2 px-1">
        <span
          className="material-symbols-outlined text-[#5ABD4F]"
          style={{ fontVariationSettings: "'FILL' 1" }}
        >
          edit_note
        </span>
        <h3 className="font-headline text-lg font-bold text-[#191c1e]">
          확인사항
        </h3>
      </div>

      <div className="space-y-3">
        <div
          className={`min-h-28 rounded-2xl border border-[#becab7]/20 p-5 shadow-sm ${
            disabled ? 'bg-[#edeef0]' : 'bg-white'
          }`}
        >
          <textarea
            value={value}
            onChange={(e) => onChange?.(e.target.value)}
            disabled={disabled}
            placeholder={
              disabled
                ? `${lockedByName || '다른 사용자'}가 입회 점검 진행 중입니다.`
                : '추가 확인사항이나 특이사항을 입력해 주세요.'
            }
            rows={4}
            className={`w-full resize-none border-none bg-transparent p-0 text-base font-medium focus:ring-0 ${
              disabled
                ? 'cursor-not-allowed text-[#3f4a3b]/60 placeholder:text-[#3f4a3b]/40'
                : 'text-[#191c1e] placeholder:text-[#3f4a3b]/50'
            }`}
          />
        </div>

        <button
          onClick={onSign}
          disabled={disabled}
          className={`font-headline flex h-12 w-full items-center justify-center gap-2 rounded-full text-base font-extrabold transition-all ${
            disabled
              ? 'cursor-not-allowed bg-[#5ABD4F]/50 text-white'
              : 'bg-[#5ABD4F] text-white shadow-lg shadow-[#5ABD4F]/20 active:scale-[0.98]'
          }`}
        >
          <span
            className="material-symbols-outlined text-xl"
            style={{ fontVariationSettings: "'FILL' 1" }}
          >
            draw
          </span>
          서명하기
        </button>
      </div>
    </section>
  );
}
